import { createStyles } from '@mantine/core';

export const useStyles = createStyles(() => ({
  contentContainer: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingTop: '0',

  },
  inputDescription: {
    marginTop: '25px',
    color: '#6f6f6f !important',
    fontSize: '12px !important',
  },
  inputError: {
    color: 'red',
  },
}));

export default useStyles;
